import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import { AvForm } from 'availity-reactstrap-validation';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../i18next';

import { convertStringToBoolean } from '../../../utils/CommonUtils';
import HeaderAndDays from '../../common/operationHours/HeaderAndDays';
import CommonSelect from './common/CommonSelect';

class SettingsModalScreen extends Component {
    constructor() {
        super();

        this.state = {
            scheduledSetting: {
                id: null,
                fromHour: null,
                fromMinute: '',
                validOnMonday: false,
                validOnTuesday: false,
                validOnWednesday: false,
                validOnThursday: false,
                validOnFriday: false,
                validOnSaturday: false,
                validOnSunday: false,
                capacity: ''
            }
        };

        this.changeState = this.changeState.bind(this);
        this.changeBooleanAttributeState = this.changeBooleanAttributeState.bind(this);
        this.submitForm = this.submitForm.bind(this);
    }

    componentDidMount() {
        if (this.props.state.editSettings) {
            let scheduledSettingsFromProps = {};
            for (const property in this.props.state.editSettings) {
                if (property === 'scheduleAtHour') {
                    scheduledSettingsFromProps.fromHour = this.props.state.editSettings[property];
                } else if (property === 'scheduleAtMinute') {
                    scheduledSettingsFromProps.fromMinute = this.props.state.editSettings[property];
                } else {
                    scheduledSettingsFromProps[property] = this.props.state.editSettings[property];
                }
            }

            this.setState({
                scheduledSetting: scheduledSettingsFromProps
            });
        }
    }

    submitForm() {
        const {
            id,
            fromHour,
            fromMinute,
            validOnMonday,
            validOnTuesday,
            validOnWednesday,
            validOnThursday,
            validOnFriday,
            validOnSaturday,
            validOnSunday,
            capacity } = this.state.scheduledSetting;

        let transformedSetting = {
            id: id,
            scheduleAtHour: fromHour,
            scheduleAtMinute: fromMinute,
            validOnMonday,
            validOnTuesday,
            validOnWednesday,
            validOnThursday,
            validOnFriday,
            validOnSaturday,
            validOnSunday,
            capacity
        };

        const isNoDaySelected = !validOnMonday && !validOnTuesday && !validOnWednesday && !validOnThursday && !validOnFriday && !validOnSaturday && !validOnSunday;
        if (isNoDaySelected) {
            this.props.dispatchErrorMessage(i18n.t('screens:preparationTimes.noDaySelected'));
            return;
        }

        this.props.createUpdateScheduledSetting(
            transformedSetting,
            () => {
                this.props.getAllScheduledSettings();
                this.props.toggle('Settings', null);
            }
        );
    }

    changeState({ target }) {

        if (target.name === 'autoScaling') {
            if (!target.options[target.selectedIndex].value) return null;

            this.setState({
                scheduledSetting: {
                    ...this.state.scheduledSetting,
                    capacity: target.options[target.selectedIndex].value
                }
            });
        } else {
            this.setState({
                scheduledSetting: {
                    ...this.state.scheduledSetting,
                    [target.name]: +target.value
                }
            })
        }

    }

    changeBooleanAttributeState({ target }) {
        const targetChecked = convertStringToBoolean(target.checked);

        this.setState({
            scheduledSetting: {
                ...this.state.scheduledSetting,
                [target.name]: targetChecked
            }
        });
    }

    render() {
        return (
            <Modal
                className='operationTimeScreen'
                isOpen={this.props.state.isSettingsOpen}
                toggle={() => this.props.toggle('Settings', null)}>
                <AvForm onValidSubmit={this.submitForm}>
                    <ModalHeader
                        className='modalHeader'
                        toggle={() => this.props.toggle('Settings', null)}
                        style={{ margin: 'auto' }}>{i18n.t('screens:systemControlContainer.selectTime')}</ModalHeader>
                    <ModalBody>
                        <HeaderAndDays
                            timeSlotBased={false}
                            preparationTime={this.state.scheduledSetting}
                            isRequired={true}
                            changeState={this.changeState}
                            changeCheckBoxState={this.changeBooleanAttributeState}
                            capacitySelect={<CommonSelect
                                changeState={this.changeState}
                                options={[32, 64, 192, 384]}
                                inputName='autoScaling'
                                inputValue={this.state.scheduledSetting.capacity}
                                defaultOptionText={i18n.t('screens:systemControlContainer.selectCapacity')}
                            />}
                            fromMinuteSelect={<CommonSelect
                                changeState={this.changeState}
                                options={[5, 35]}
                                inputName='fromMinute'
                                inputValue={this.state.scheduledSetting.fromMinute}
                                defaultOptionText={'mm'}
                            />}
                            minuteSelect={null} />
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary">
                            <MaterialIcon icon="check" color="#fff" size={20} />&nbsp;{i18n.t('common:buttons.save')}
                        </Button>
                    </ModalFooter>
                </AvForm>
            </Modal>
        );
    }
}

export default SettingsModalScreen;


// WEBPACK FOOTER //
// ./src/components/systemControl/database/SettingsModalScreen.js